import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { api } from './api/api';
import { listenerMiddleware } from './listener';
import { filtersSlice } from './slices/filtersSlice';
import { uiSlice } from './slices/uiSlice';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [filtersSlice.name]: filtersSlice.reducer,
  [uiSlice.name]: uiSlice.reducer,
});

export function makeStore(preloadedState?: Partial<ReturnType<typeof rootReducer>>) {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefault) =>
      getDefault().prepend(listenerMiddleware.middleware).concat(api.middleware),
    // deepdive-v2 checked import.meta.env.NODE_ENV, which Vite never defines — devtools shipped to prod.
    devTools: import.meta.env.DEV,
  });
  // Enables refetchOnFocus / refetchOnReconnect (v2 never called this).
  setupListeners(store.dispatch);
  return store;
}

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore['dispatch'];
